import { LoadingButton } from '@panwds/react-ui';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
/**
 * A button to submit a form
 */
export function SubmitButton({ children = 'Submit', disabled = false, ...passThrough }) {
    const { formState } = useFormContext();
    const { isSubmitting, isSubmitSuccessful, isValid } = formState;
    const [dataResult, setDataResult] = useState({
        loading: false,
        success: false
    });
    const onClickCallback = () => {
        setDataResult({
            loading: isSubmitting && isValid,
            success: isSubmitSuccessful
        });
    };
    return (React.createElement(LoadingButton, { role: "button", ...passThrough, onClickCallback: onClickCallback, dataResult: dataResult, appearance: "primary", type: "submit", disabled: disabled || isSubmitting }, children));
}
//# sourceMappingURL=SubmitButton.js.map